import React, { useEffect, useState } from 'react';
import Selection from '../../selection';

function Contractor(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        setDisplay(displayPage())
    }, [props.page, props.store])

    function displayPage() {
        switch (props.page) {
            case 21:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "What's your daily rate?",
                        content: "This helps lenders understand how and what they can offer to lend you.",
                        input: {
                            type: "number",
                            placeholder: "0",
                            id: "contractor_rate",
                            next: 22
                        }
                    }} id={"contractor_rate"} setValue={(e) => props.setValue({ ...props.store, contractor_rate: e })} />
                )
        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default Contractor;